import { apiUrl } from "@/api/client";
import { useAuthStore } from "@/stores/auth";

/** Parse the viewBox of an SVG document → its natural pixel size. */
export function svgViewBoxSize(svg: string): { width: number; height: number } | null {
  const m = svg.match(/viewBox="\s*[\d.+-]+[\s,]+[\d.+-]+[\s,]+([\d.+]+)[\s,]+([\d.+]+)\s*"/);
  if (!m) return null;
  const width = Math.round(Number(m[1]));
  const height = Math.round(Number(m[2]));
  if (!width || !height) return null;
  return { width, height };
}

/**
 * Server-side SVG → PNG via the Remotion-bundled Chromium (same engine as
 * the preview, so embedded fonts rasterize identically). Send the FULLY
 * substituted + font-embedded source.
 */
export async function rasterizeSvgToPng(
  svg: string,
  width: number,
  height: number,
): Promise<Blob> {
  const res = await fetch(apiUrl("/svg/rasterize"), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${useAuthStore.getState().token}`,
    },
    body: JSON.stringify({ svg, width, height }),
  });
  if (!res.ok) {
    let msg = `PNG export failed (${res.status})`;
    try {
      const j = (await res.json()) as { error?: string; message?: string };
      msg = j.error ?? j.message ?? msg;
    } catch {
      // non-JSON error body — keep the status message
    }
    throw new Error(msg);
  }
  return res.blob();
}
